const INFO = {
	main: {
		title: "Pavan",
		name: "Pavan",
		fullName: "Pavan Khiani",
		url: "https://pavankhiani.xyz",
		logo: "../Pavan Icon.png",
		expertise: [
			"Product management",
			"Building monetizable products",
			"Product strategy",
			"Pricing and monetization",
			"MVP development",
			"AI-assisted development (vibe coding)",
			"Creator economy",
		],
	},

	socials: {
		github: "https://github.com/pkhiani",
		linkedin: "https://linkedin.com/in/pavan-khiani",
		twitter: "https://x.com/pavan_khi",
		medium: "https://pkhiani.medium.com/",
		spotify: "https://open.spotify.com/show/5dlhqXHwdjDkiuOOvhcRa5?si=3063c552d402433f"
	},

	homepage: {
		title: "I help experts and creators build products people pay for.",
		description:
			"Anyone can vibe code an app now. Knowing what to build, and how to make money from it, is still the hard part. I'm a product manager who has launched my own AI tools and apps, and I help industry experts and creators turn what they know into real products.",
	},

	services: {
		title: "Why AI alone isn't enough",
		description:
			"AI coding tools will build whatever you ask for. But they don't know your audience, your market, or what people will actually pay for, and they rarely push back when the idea or the business model is wrong. Their direction is only as good as the context you give them. That's the part I bring: product judgment plus the speed of building with AI. You bring the expertise and the audience.",
		steps: [
			{
				title: "Find the product",
				description:
					"Validate demand, define the offer, and choose a pricing model before writing any code.",
			},
			{
				title: "Build it fast",
				description:
					"Ship an MVP in weeks, not quarters: an AI tool, web app, mobile app, or paid platform.",
			},
			{
				title: "Launch & monetize",
				description:
					"Payments, subscriptions, onboarding, and analytics, plus the iteration loop that turns an audience into recurring revenue.",
			},
		],
		cta: {
			text: "Have expertise or an audience? Let's build your product.",
			linkText: "Message me on LinkedIn",
		},
	},

	projectsTitle: "Products I've shipped",

	work: {
		title: "Experience",
		roles: [
			{
				company: "TELUS",
				role: "Product Manager",
				duration: "2024 - Present",
				logo: "./telus.svg",
			},
			{
				company: "RBC",
				role: "Product Analyst",
				duration: "2023",
				logo: "./rbc.png",
			},
			{
				company: "KPMG",
				role: "Product Owner",
				duration: "2022",
				logo: "./kpmg.png",
			},
		],
	},

	projects: [
		{
			title: "Well Earned: Earn Screen Time",
			description:
				"Live more offline",
			about:
				"iOS habit tracker and screen time blocker where users earn their screen time by completing healthy habits.",
			logo: "/well-earned-logo.png",
			linkText: "View Project",
			link: "https://apps.apple.com/us/app/well-earned-earn-screen-time/id6757367210",
		},
		{
			title: "Asymmetrix",
			description:
				"Find 10x Stocks Early",
			about:
				"AI-powered stock research that surfaces social signals and trade analysis to help investors find 10x stocks early.",
			logo: "/asymmetrix-logo.png",
			linkText: "View Project",
			link: "https://asymmetrix.xyz",
		},
		{
			title: "PM Prep",
			description:
				"Master the Art of the Product Interview",
			about:
				"Interview prep platform where candidates practice real product management scenarios with guided reflection and personalized feedback.",
			logo: "/pmprep-logo.png",
			linkText: "View Project",
			link: "https://pmprep.xyz/",
		},
	],
};

export default INFO;
